var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveChartPref(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.667 0v4c0 .733.6 1.333 1.37 1.333H12V14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h4.667zM5.166 1.5H2a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V6.833H8.038c-1.53 0-2.78-1.17-2.866-2.666L5.167 4l-.001-2.5zm-.272 5.25a.66.66 0 0 1 .486.198.66.66 0 0 1 .198.485v3.983l1.043-1.044a.639.639 0 0 1 .482-.201.699.699 0 0 1 .685.689.637.637 0 0 1-.2.48l-2.212 2.216a.632.632 0 0 1-.224.147.721.721 0 0 1-.515 0 .632.632 0 0 1-.224-.147L2.196 11.34A.634.634 0 0 1 2 10.862a.695.695 0 0 1 .682-.69.644.644 0 0 1 .485.2l1.044 1.044V7.433a.66.66 0 0 1 .198-.485.66.66 0 0 1 .485-.198zM8.074.427a.25.25 0 0 1 .353 0l3.146 3.146a.25.25 0 0 1-.177.427H8.25A.25.25 0 0 1 8 3.75V.604a.25.25 0 0 1 .073-.177z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveChartPref);
export default __webpack_public_path__ + "static/media/save-chart-pref.b6bf1f0f5b77d7577e75d83dc9f89de3.svg";
export { ForwardRef as ReactComponent };